// extracted by mini-css-extract-plugin
export default {"card":"F1-z","carouselContainer":"G1-z","carouselContent":"H1-z"};